/**
 * @class
 */
import Base from '@netx/core/lib/netx-collection';
import Model from '../models/notification';

export default class Notifications extends Base {
	/**
	 * Sort descending
	 * @type {string}
	 * @param {Netx.Models.Notification} model Notification model
	 */
	comparator(model) {
		return -model.get('creationTime');
	}

	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);

		/** @type {string} */
		this.localStorageKey = opts.localStorageKey || 'notifications';

		/** @type {number} */
		this.maxStore = opts.maxStore || 100;

		// Hey, listen
		this.listenTo(this, 'sync', this.checkNotifications);
	}

	/**
	 * @method
	 * @todo: Go through notifications, check for progress tasks, check to see if the tasks are still in progress
	 */
	checkNotifications() {
		this.each((model) => {
			if (model.get('progressTask')) {
				//dispatcher.trigger('notification:batch:task', model );
			}
		});
	}

	/**
	 * Modify the model object that came back from local storage before inserting it into the collection
	 * @override
	 * @param {object} obj Model data object
	 * @return {object} Model data
	 */
	parseLocalStorageModelIn(obj) {
		// Do not load any corrupted/empty notification local sotrage records
		if (obj && obj.title && obj.type) {
			return obj;
		}
	}

	/** @type {string} */
	static get __name__() {
		return 'Notifications';
	}
}
